/** Where a task dragged by `dyWorld` from row `from` lands: the nearest row, within the list (`taskMove`'s index). */
export function dropIndex(from: number, dyWorld: number, rowH: number, count: number): number {
  return Math.min(Math.max(0, from + Math.round(dyWorld / rowH)), Math.max(0, count - 1));
}
